import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import AuthGuard from 'src/views/authentication/auth/AuthGuard';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const Dashboard = Loadable(lazy(() => import('../views/dashboard/Dashboard')));
const Users = Loadable(lazy(() => import('../views/users/Users')));
const AddEditUser = Loadable(lazy(() => import('../views/users/AddEditUser')));
const ClientStatus = Loadable(lazy(() => import('../views/ClientStatus')));
const ClientStatusView = Loadable(lazy(() => import('../views/ClientStatus/View')));
const VideoArchive = Loadable(lazy(() => import('../views/VideoArchive')));
const VideoArchiveView = Loadable(lazy(() => import('../views/VideoArchive/View')));
const Billing = Loadable(lazy(() => import('../views/Billing')));
const AddEditBilling = Loadable(lazy(() => import('../views/Billing/AddEditBilling')));
const ViewBilling = Loadable(lazy(() => import('../views/Billing/View')));
const DeliveryStatus = Loadable(lazy(() => import('../views/DeliveryStatus')));
const Contact = Loadable(lazy(() => import('../views/Contact')));
const ContactView = Loadable(lazy(() => import('../views/Contact/View')));
const ViewUser = Loadable(lazy(() => import('../views/users/View')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Login = Loadable(lazy(() => import('../views/authentication/Login')));

const Router = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <Navigate to="/users" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/users', exact: true, element: <Users /> },
      { path: '/user-add', exact: true, element: <AddEditUser /> },
      { path: '/user-edit/:id', exact: true, element: <AddEditUser /> },
      { path: '/users/:id', exact: true, element: <ViewUser /> },
      { path: '/client-status', exact: true, element: <ClientStatus /> },
      { path: '/client-status/:id', exact: true, element: <ClientStatusView /> },
      { path: '/video-archive', exact: true, element: <VideoArchive /> },
      { path: '/video-archive/:id', exact: true, element: <VideoArchiveView /> },
      { path: '/billing', exact: true, element: <Billing /> },
      { path: '/billing-add', exact: true, element: <AddEditBilling /> },
      { path: '/billing/:id', exact: true, element: <AddEditBilling /> },
      { path: '/billing-view/:id', exact: true, element: <ViewBilling /> },
      { path: '/delivery-status', exact: true, element: <DeliveryStatus /> },
      { path: '/contacts', exact: true, element: <Contact /> },
      { path: '/contact-view/:id', exact: true, element: <ContactView /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [{ path: '/auth/login', element: <Login /> }],
  },
  { path: '*', element: <Error /> },
];

export default Router;
